<template>
    <div class="goodsList">
        <status-tabs :status.sync="status" :statusList="statusList"></status-tabs>

        <search-tool ref="searchTool" :status="status" :statusList="statusList" :funcName="funcName"
            :searchForm="searchForm" :searchList="searchList" :searchForm_transfer="searchForm_transfer" :inputPlaceholder="inputPlaceholder"
            listName="products" :loading="loading"></search-tool>
        <div class="goods-container" ref="goodsContainer" :style="{ height: height }">
            <div ref="treeWrap" class="tree-wrap" @mouseleave="inCategory = false">
                <div :class="`multi-filter-item${setCategory === 1 && ' no-border' || ''}`">
                    <div class="header">
                        <div class="title"> Categories </div>
                        <div class="header-right"></div>
                    </div>
                    <div class="category-group-list">
                        <ul class="category-list" id="categoryList" @mouseenter="inCategory = true" >
                            <li v-for="(c, i) in treeData" :key="i" @mouseenter="setCurrentCategoryChildren(c)">
                                <a rel="nofollow" class="category-name-list-item" href="#"
                                    :ids="JSON.stringify([0, c.id])" @click="selectCategory">
                                    <span class="category-name-txt">{{
                                            c.name
                                    }}</span>
                                    <i v-if="c.total" class="category-count-txt">({{ c.total }})</i>
                                </a>

                                <div class="arrow" v-if="c.cat_id"></div>
                            </li>
                        </ul>
                        <div v-show="inCategory && currentCategoryChildren.length > 0" class="sub-category-list" @mouseenter="inCategory = true" @mouseleave="inCategory = false">
                            <div>
                                <template v-for="cc in currentCategoryChildren">
                                    <div v-if="cc.cat_id" :key="cc.id" class="category-item-list">
                                        <div class="title"><a href="#" :ids="JSON.stringify([0, topCategoryId, cc.id])" @click="selectCategory">{{cc.name}}</a></div>
                                        <ul class="child-list">
                                            <li v-for="ccc in cc.cat_id" :key="ccc.id">
                                                <a href="#" :ids="JSON.stringify([0, topCategoryId, cc.id, ccc.id])" @click="selectCategory">{{ccc.name}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </template>

                                <template v-if="currentCategoryChildren.filter(c => !c.cat_id).length > 0">
                                    <div class="category-item-list">
                                        <div v-for="cc in currentCategoryChildren" :key="cc.id" class="title">
                                            <a v-if="!cc.cat_id" href="#" :ids="JSON.stringify([0, topCategoryId, cc.id])" @click="selectCategory">{{cc.name}}</a>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="goods-wrap" v-show="!showDetail">
                <div class="filter-wrap">
                    <div class="nav" ref="navContainer">
                        <el-breadcrumb ref="navItems" separator-class="el-icon-arrow-right">
                            <template v-for="(n,i) in navList">
                                <el-breadcrumb-item v-if="i < navList.length - 1" :key="i" :ids="JSON.stringify(navList.filter((_,j) => j <= i).map(n => n.id))" @click.native="selectCategory">{{n.name}}</el-breadcrumb-item>
                            </template>
                            <el-breadcrumb-item>{{navList[navList.length - 1].name}}</el-breadcrumb-item>
                        </el-breadcrumb>
                        <div v-show="filterSetted.tags.length > 0 || filterSetted.price[0] > 0 || filterSetted.price[1] > 0" class="selected-tags" :style="{width:`calc(100% - ${navWidth}px - 30px)`}">
                            <el-tag v-for="item in filterSetted.tags" :key="item.id" closable disable-transitions effect="plain" @close="setTag(item)">
                                {{item.name}}
                            </el-tag>
                            <el-tag v-if="filterSetted.price[0] > 0 || filterSetted.price[1] > 0" closable disable-transitions effect="plain" @close="filterSetted.price=[undefined,undefined]">Price: ${{filterSetted.price[0] || 0}} ~ {{filterSetted.price[1] > 0 && '$'+filterSetted.price[1] || ''}}</el-tag>
                            <a href="#" class="cleaner" v-show="filterSetted.tags.length > 1 || filterSetted.tags.length > 0 && (filterSetted.price[0] > 0 || filterSetted.price[1] > 0)" @click="(e)=>{e.preventDefault();filterSetted={tags:[],price:[undefined,undefined]}}"><i class="el-icon-delete"></i>Clear</a>
                        </div>
                    </div>

                    <el-button-group ref="controlBtns" class="control-btns">
                        <el-button type="primary" @click="selectFn">
                            <img class="select-img" :src="[
                                selectState
                                    ? require('@/assets/image/select-all.svg')
                                    : require('@/assets/image/not-all.svg'),
                            ]" />
                            <span class="select-label">{{ selectTotal }} items selected</span>
                        </el-button>
                        <el-button type="primary" @click="publish">Batch Publish</el-button>
                        <el-button type="primary" @click="batchDownload">Download</el-button>
                        <el-button type="primary" @mouseenter.native="setShowSortList(true)" @mouseleave.native="setShowSortList(false)">
                            Sort By <span class="sort-type">{{sortBy}}</span>
                            <i :class="`el-icon-arrow-${showSortList&&'up'||'down'}`"></i>
                            <ul v-show="showSortList" class="sort-list">
                                <li v-for="(item, i) in sortByList" :key="i" :value="item.sort" :class="sortBy===item.name&&'active'||''"><a href="#" @click="(e)=>{e.preventDefault();sortBy=item.name;sortById=item.sort;showSortList=false;getGoodsList()}">{{item.name}}</a></li>
                            </ul>
                        </el-button>
                        <el-button ref="controlBtnsFilter" type="primary" @mouseenter.native="setShowFilterList(true)" @mouseleave.native="setShowFilterList(false)">
                            Filter By<i :class="`el-icon-arrow-${showFilterList&&'up'||'down'}`"></i>
                            <div v-show="showFilterList" class="filter" :style="{...filterStyle()}">
                                <div class="tag-group" v-for="tag in tagList" :key="tag.id">
                                    <div class="group-name">{{tag.name}}</div>
                                    <div class="item-list">
                                        <a href="#" v-for="item in tag.cat_id" :key="item.id" @click="(e)=>{e.preventDefault();setTmpTag(item)}" :class="filterSettedTmp.tags.find(it => it.id == item.id) && 'active' || ''">{{item.name}}
                                            <span><i class="checked"></i></span>
                                        </a>
                                    </div>
                                </div>
                                <div class="tag-group">
                                    <div class="group-name">Processing Time</div>
                                    <div class="item-list">
                                        <a href="#" v-for="item in processingList" :key="item.value" @click="(e)=>{e.preventDefault();setTmpTime(item)}" :class="filterSettedTmp.processing_time.find(it => it.value == item.value) && 'active' || ''">{{item.label}}
                                            <span><i class="checked"></i></span>
                                        </a>
                                    </div>
                                </div>
                                <div class="tag-group">
                                    <div class="group-name">Price</div>
                                    <div class="item-list">
                                        <div class="price-range">
                                            <el-input class="min" size="mini" placeholder="Min" type="number" v-model="filterSettedTmp.price[0]"></el-input>
                                            ~
                                            <el-input class="max" size="mini" placeholder="Max" type="number" v-model="filterSettedTmp.price[1]"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <el-row>
                                    <el-button size="mini" type="primary" @click="confirmFilter()">Submit</el-button>
                                    <el-button size="mini" type="info" @click="setShowFilterList(false)">Close</el-button>
                                </el-row>
                            </div>
                        </el-button>
                    </el-button-group>
                </div>
                <el-scrollbar :style="{ height: `calc(100% - 56px - ${navHeight}px - 10px)` }">
                    <div class="goods-list" ref="goodsListRef">
                        <div class="cards-wrap" v-if="goodsList.length > 0">
                            <div class="card-item" :style="{ marginRight: width(i) + 'px' }"
                                :class="{ 'card-item-select': item.select }" v-for="(item, i) of goodsList"
                                :key="item.id">
                                <div class="check-box" @click.stop="chioceGoods(i)">
                                    <img :src="[
                                        item.select
                                            ? require('@/assets/image/select-all.svg')
                                            : require('@/assets/image/not-select.svg'),
                                    ]" />
                                </div>
                                <div class="thumb" @click="toDetail(item)" v-ga="{
                                    eventCategory: 'engagement',
                                    eventAction: 'view_item',
                                }">
                                    <el-image :lazy="!showDetail" :src="
                                        ossImg(item.goods_images &&
                                        item.goods_images[0], 208, 208)
                                    " fit="contain">
                                        <div slot="error" class="image-slot">
                                            <i class="el-icon-picture-outline"></i>
                                        </div>
                                    </el-image>
                                </div>
                                <div class="product-detail">
                                    <p class="title">{{ item.goods_name }}</p>
                                    <p class="subtitle" v-if="roleId != 1">
                                        <span>As low as</span>
                                        <span class="subtitle-price">{{
                                                item.currency + item.price
                                        }}</span>
                                    </p>
                                    <div class="operations">
                                        <el-button type="primary" size="mini" @click="toDetail(item)">Add To Cart
                                        </el-button>
                                        <el-tooltip effect="dark"
                                            content="A Zip file containing the detailed info of the product, such as images, description and price, will be downloaded."
                                            placement="top">
                                            <el-image :src="
                                                require('@/assets/image/goods/download.svg')
                                            " @click="download(item.id)"></el-image>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <el-empty :image-size="200" :style="{ height: 'calc(100% - 45px)' }" v-else></el-empty>
                    </div>
                </el-scrollbar>
                <pagination style="text-align: left" :paginationData="paginationData"
                    @paginationChange="paginationChange" :funcName="funcName"></pagination>
            </div>
            <div class="goods-detail" v-show="showDetail">
                <router-view></router-view>
            </div>
        </div>
        <selectPlatform
            :selectPlatformVisible.sync="selectPlatformVisible"
            :selectList="selectList"
        ></selectPlatform>
        <batchDownload
            :downloadVisible.sync="downloadVisible"
            :selectList="selectList"
        ></batchDownload>
        <!-- <generate :generateVisible.sync="generateVisible"></generate> -->
        <selectShop :id="id" :selectShopVisible.sync="selectShopVisible"></selectShop>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState, mapMutations } from "vuex";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import util from "@/utils/util.js";
import menuAuthBtn from "@/common/components/menuAuthBtn";
import statusTabs from "../../../common/components/table/status_tabs.vue";
import searchTool from "../../../common/components/search-tool.vue";
import pagination from "@/common/components/pagination.vue";
import selectPlatform from "./goodsList/selectPlatform.vue"; // 批量
//import generate from "@/common/components/generateDialog.vue";
import selectShop from "./goodsList/selectShop.vue";
import batchDownload from "./goodsList/batchDownload.vue";

export default {
    mixins: [infoTagsMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Product Name、SPU、SKU",
            searchForm: {
                keyword: "",
                status: "",
                new_arrival: "",
                price: "",
                weight: "",
                delivery_time: "",
                tags: [],
                processing_time: [],
            },
            searchForm_transfer: {
                status: "",
            },
            id: "",
            hasSearchCondition: false,
            authKeyList: [],
            status: "",
            statusList: [],
            selectList: [],
            countryList: [],
            shop_name: "",
            shop_id: "",
            platformList: [],
            menuAuth: [],
            loading: false,
            funcName: "getGoodsList",
            selectTotal: 0,
            selectState: false,
            selectedSrc: require("@/assets/image/not-all.svg"),
            treeData: [],
            setCategory: 1,
            paginationData: {
                page: 1,
                "per-page": 50,
                total: "",
            },
            defaultProps: {
                children: "cat_id",
                label: "name_en",
            },
            category_id: "",
            topCategoryId: 0,
            currentCategoryChildren: [],
            inCategory: false,
            navList: [{
                id: 0,
                name: 'All products'
            }],
            navWidth: 0,
            navHeight: 33,
            showSortList: false,
            sortByList:[
                {
                    "sort":1,
                    "name":"Newest"
                },
                {
                    "sort":2,
                    "name":"Price: High to Low"
                },
                {
                    "sort":3,
                    "name":"Price: Low to High"
                },
                {
                    "sort":4,
                    "name":"Best Selling"
                },
     
            ],
            processingList:[
                {
                    label: "1-3 days",
                    value: 1,
                },
                {
                    label: "3-5 days",
                    value: 2,
                },
                {
                    label: "5-7 days",
                    value: 3,
                },
                {
                    label: "More than 7 days",
                    value: 4,
                },
            ],
            showSortInterval: null,
            sortBy: 'Newest',
            sortById: 1,
            showFilterList: false,
            showFilterInterval: null,
            filterSetted: {
                tags: [],
                price: [undefined, undefined],
                processing_time: [],
            },
            filterSettedTmp: {
                tags: [],
                price: [undefined, undefined],
                processing_time: [],
            },
            goodsList: [],
            showDetail: false,
            category_total: "",
            scroll: "",
            selectPlatformVisible: false,
            downloadVisible: false,
            filterPopover: false,
            filterPopoverItems: {
                monthList: [
                    {
                        id: 0,
                        label: "ALL",
                        value: "",
                    },
                    {
                        id: 1,
                        label: "2022-01",
                        value: "2022-01",
                    },
                    {
                        id: 2,
                        label: "2021-12",
                        value: "2021-12",
                    },
                    {
                        id: 3,
                        label: "2021-11",
                        value: "2021-11",
                    },
                    {
                        id: 4,
                        label: "2021-10",
                        value: "2021-10",
                    },
                    {
                        id: 5,
                        label: "2021-09",
                        value: "2021-09",
                    },
                ],
                new_arrival: 0,
                priceList: [
                    {
                        id: 0,
                        label: "ALL",
                        value: "",
                    },
                    {
                        id: 1,
                        label: "1~10",
                        value: "1~10",
                    },
                    {
                        id: 2,
                        label: "10~20",
                        value: "10~20",
                    },
                    {
                        id: 3,
                        label: "20~40",
                        value: "20~40",
                    },
                    {
                        id: 4,
                        label: "40~60",
                        value: "40~60",
                    },
                    {
                        id: 5,
                        label: ">60",
                        value: ">60",
                    },
                ],
                price: 0,
                weightList: [
                    {
                        id: 0,
                        label: "ALL",
                        value: "",
                    },
                    {
                        id: 1,
                        label: "0~100g",
                        value: "0~100g",
                    },
                    {
                        id: 2,
                        label: "100~200g",
                        value: "100~200g",
                    },
                    {
                        id: 3,
                        label: "200~400g",
                        value: "200~400g",
                    },
                    {
                        id: 4,
                        label: ">400g",
                        value: ">400g",
                    },
                ],
                weight: 0,
                timeList: [
                    {
                        id: 0,
                        label: "ALL",
                        value: "",
                    },
                    {
                        id: 1,
                        label: "0~2",
                        value: "0~2",
                    },
                    {
                        id: 2,
                        label: "2~3",
                        value: "2~3",
                    },
                    {
                        id: 3,
                        label: "3~4",
                        value: "3~4",
                    },
                    {
                        id: 4,
                        label: ">4",
                        value: ">4",
                    },
                ],
                delivery_time: 0,
            },
            subPageRefresh: false,
            subPageRefreshRoute: {},
            roleId: "",
            actualColumns: 1,
            minPrice: "",
            maxPirce: "",
            tagList: [],
            catParents: [],
            levelMore_1: false,
            levelMore_2: false,
            levelMore_3: false,
            //generateVisible: false,
            selectShopVisible: false,
            ossImg: util.ossImg
        };
    },
    methods: {
        ...mapMutations(['REPLACEQUERY']),
        download(id) {
            this.id = id;
            this.selectShopVisible = true;
            // cmofferApi.download({ id }, "get").then((res) => {
            //     // console.log(res);
            //     if (res.errcode == 0) {
            //         this.generateVisible = true;
            //     }
            // });
        },
        shopName(val) {
            this.shop_name = val;
        },
        shopId(val) {
            this.shop_id = val;
        },
        //平台下拉列表获取
        async platformSelect() {
            cmofferApi.platformSelect({}, "get").then((res) => {
                if (res) {
                    this.platformList = res.data;
                }
            });
        },
        authFunc(funcName) {
            this[funcName]();
        },
        import() {
            this.importVisible = true;
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        shop_transfer() {
            this.searchForm = Object.assign(
                this.searchForm,
                this.searchForm_transfer
            );
        },
        async initialize() {
            this.platformSelect();
            this.getGoodsList();
            this.getProductCategory();
            this.handleScroll();
            this.goodsTags();
        },
        handleScroll() {
            this.$refs.goodsListRef.addEventListener("scroll", () => {
                this.scroll =
                    this.$refs.goodsListRef &&
                    this.$refs.goodsListRef.scrollTop;
            });
        },
        // 全选/全不选
        selectFn() {
            this.selectState = !this.selectState;
            this.goodsList.forEach((item, i, arr) => {
                arr[i].select = this.selectState;
                this.$set(arr[i], "select", arr[i].select);
                if (item.select) {
                    this.goodsSelectdList.push(item.id);
                }
            });
            this.$store.commit("GOODSSELECTED_LIST", [
                ...new Set(this.goodsSelectdList),
            ]);
            if (this.selectState) {
                this.selectTotal = this.goodsSelectdList.length;
            } else {
                this.selectTotal = 0;
                this.$store.commit("GOODSSELECTED_LIST", []);
            }
        },
        // 获取商品列表
        getGoodsList(page, type) {
            this.goodsSelectdList = [];
            this.selectTotal = this.goodsSelectdList.length;
            this.selectTotal = 0;
            this.$store.commit("GOODSSELECTED_LIST", []);

            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            this.showDetail = false; // 隐藏商品详情页
            // 解决在商品详情页, 搜索其他商品后, 进入详情页,商品信息没改变
            /* this.$router.replace({
                path: "/goodsList",
            }); */
            cmofferApi
                .productList(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        catalog_id: this.category_id,
                        preferred: type == "preferred" ? 1 : 0,
                        promotion: type == "promotion" ? 1 : 0,
                        tags: this.filterSetted.tags.map((item) => {
                                return item.id;
                            }),
                        price: this.filterSetted.price,
                        processing_time: this.filterSetted.processing_time.map(t => t.value),
                        sortby:this.sortById
                    },
                    "get"
                )
                .then((res) => {
                    this.loading = false;
                    if (res.errcode == 0) {
                        this.goodsList = res.data;
                        this.paginationData.total = res.total;
                        this.loading = false;
                        this.setCategory = res.setCategory || 0;
                        this.goodsList.forEach((item, i, arr) => {
                            this.$set(arr[i], "select", false);
                            // 自动勾选已被缓存起来的商品
                            this.goodsSelectdList.forEach((sItem) => {
                                if (item.id == sItem) {
                                    this.$set(arr[i], "select", true);
                                }
                            });
                            this.selectTotal = this.goodsSelectdList.length; // 设置选中总数
                            this.filterPopover = false;
                        });
                    }
                });
        },
        getProductCategory() {
            cmofferApi.goodsCategory({}, "get").then((res) => {
                if (res.errcode == 0) {
                    this.treeData = res.data;
                    this.category_total = res.goods_total;


                    if (this.$route.query && this.$route.query.category_id && this.$route.query.catParents) {
                        this.catParents = this.$route.query.catParents.split(',').map(id => parseInt(id))
                        this.setNavList()
                    }
                }
            });
        },
        selectCategory(evt) {
            const { target } = evt;
            const a =
                (target.tagName === "SPAN" && target.parentElement) || target;
            evt.preventDefault();
            this.catParents = JSON.parse(a.getAttribute("ids"));
            this.category_id = this.catParents[this.catParents.length - 1];

            // url携带参数
            this.REPLACEQUERY({
                category_id: this.category_id,
                catParents: this.catParents.toString(),
                keyword: this.searchForm.keyword,
                tags: this.searchForm.tags.toString(),
            });

            // this.levelMore_1 = false;
            // this.levelMore_2 = false;
            // this.levelMore_3 = false;

            this.setNavList()

            this.filterSetted = {
                tags: [],
                price: [undefined, undefined],
                processing_time:[],
            }

            this.getGoodsList(1);

            this.inCategory = false
        },
        setNavList() {
            let currentCat = []
            this.navList = [{id: 0, name: 'All products'}]
            for (let i = 1; i < Math.min(this.catParents.length, 4); i++) {
                const id = parseInt(this.catParents[i])
                currentCat = (i < 2 && this.treeData || currentCat.cat_id).find(t => t.id === id)

                this.navList.push({id, name: currentCat.name})
            }

            // this.$nextTick(function(){
            //     this.navWidth = this.$refs.navItems.$el.offsetWidth
            // })
        },
        setCurrentCategoryChildren(category) {
            this.topCategoryId = category.id
            this.currentCategoryChildren = category.cat_id || []
        },
        handleNodeClick(data) {
            this.category_id = data.id;
            this.getGoodsList(1);
        },
        filterGoods(type) {
            type == "all" ? (this.category_id = "") : "";
            this.getGoodsList();
        },
        toDetail(item) {
            this.showDetail = true;
            this.$router.push({
                name: `goodsDetail`,
                query: {
                    id: item.id,
                },
            });
        },
        // 选择商品
        chioceGoods(i) {
            this.goodsList[i].select = !this.goodsList[i].select;
            this.$set(this.goodsList[i], "select", this.goodsList[i].select);
            // 将商品的id暂存
            this.goodsList.forEach((item, i) => {
                // 选中
                if (item.select) {
                    this.goodsSelectdList.push(item.id);
                }
                // 未选中
                else {
                    this.goodsSelectdList.forEach((sItem, si) => {
                        if (item.id == sItem) {
                            this.goodsSelectdList.splice(si, 1);
                        }
                    });
                }
            });
            this.$store.commit("GOODSSELECTED_LIST", [
                ...new Set(this.goodsSelectdList),
            ]);
            this.selectTotal = this.goodsSelectdList.length; // 设置选中总数
        },
        publish() {
            if (this.goodsSelectdList.length != 0) {
                this.selectList = [];
                this.selectPlatformVisible = true;
                this.goodsList.forEach((item) => {
                    if (item.select) {
                        this.selectList.push(item.id);
                    }
                });
            } else {
                this.$message.warning(
                    this.$t("goodsList.list.batchPublicationTip")
                );
            }
        },
        batchDownload(){
            if (this.goodsSelectdList.length != 0) {
                this.selectList = [];
                this.downloadVisible = true;
                this.goodsList.forEach((item) => {
                    if (item.select) {
                        this.selectList.push(item.id);
                    }
                });
            } else {
                this.$message.warning(
                    this.$t("goodsList.list.batchPublicationTip")
                );
            }
        },
        filter() { },
        changeFilter(v, item) {
            this.searchForm[`${v}`] = item.value;
            this.filterPopoverItems[`${v}`] = item.id;
        },
        filterSearch() {
            this.getGoodsList();
        },
        width(i) {
            const columns = Math.floor(
                (this.$refs.goodsContainer.offsetWidth -
                    this.$refs.treeWrap.offsetWidth -
                    30 +
                    25) /
                (240 + 25)
            );
            if (columns > 0) {
                this.actualColumns = columns;
            }
            return ((i + 1) % this.actualColumns > 0 && 25) || 0;
        },
        allProducts() {
            // 初始化筛选
            this.category_id = "";
            this.initTagsHeight();
            this.getGoodsList(1);
            this.getProductCategory();
        },
        okFn() {
            if (!this.minPrice && !this.maxPirce) return;
            this.searchForm.price = `${this.minPrice}~${this.maxPirce}`;
            this.getGoodsList();
        },
        cancelFilter(i, si, sItem) {
            this.$set(this.tagList[i]["cat_id"][si], "index", null);
            if (this.searchForm.tags.length > 0) {
                this.searchForm.tags.forEach((item, index, arr) => {
                    item == sItem.id && arr.splice(index, 1);
                });
                // url携带参数
                this.REPLACEQUERY({
                    category_id: this.category_id,
                    catParents: this.catParents.toString(),
                    keyword: this.searchForm.keyword,
                    tags: this.searchForm.tags.toString(),
                });
                // this.routeObj.query.tags = this.searchForm.tags;
                // this.$router.replace(this.routeObj)
            }
            this.getGoodsList();
            // 激活状态样式多出来的12px, 取消选中需减去该高度
            this.$refs["multiShip" + i][0].style.height = `${this.$refs["multiShip" + i][0].offsetHeight - 12
                }px`;
        },
        checkFilter(i, si, sItem) {
            // console.log(this.$refs[`shipItem${i}${si}`][0].className);
            if (
                this.$refs[`shipItem${i}${si}`][0].className.indexOf("active") == -1
            ) {
                this.$set(this.tagList[i]["cat_id"][si], "index", si);
                this.searchForm.tags.push(sItem.id);
                // url携带参数
                this.REPLACEQUERY({
                    category_id: this.category_id,
                    catParents: this.catParents.toString(),
                    keyword: this.searchForm.keyword,
                    tags: this.searchForm.tags.toString(),
                });
                this.getGoodsList();
                this.$refs["multiShip" + i][0].style.height = `${this.$refs["multiShip" + i][0].offsetHeight + 12
                    }px`;
            }
        },
        // 获取tags
        goodsTags() {
            cmofferApi.goodsTags({}, "get").then((res) => {
                if (res) {
                    this.tagList = res.data;
                    this.tagList.forEach((item, i) => {
                        if (item.cat_id.length > 3) {
                            this.$set(item, "collapse", false);
                        } else {
                            this.$set(item, "collapse", "null");
                        }
                        // 如果tags有值，默认设置tags激活样式
                        item.cat_id.forEach((sitem, si) => {
                            this.searchForm.tags.forEach((stitem, sti) => {
                                if (sitem.id == stitem) {
                                    this.$set(sitem, "index", si)
                                }
                            })
                        });
                        // 获取url携带的tags，设置激活样式
                        this.$nextTick(() => {
                            let height = 100;
                            let activeNum = 0;
                            const ref = this.$refs["multiShip" + i]
                            if (!ref) return

                            let multiShipEl = ref[0];
                            // 获取激活项数量
                            let pList = multiShipEl.querySelectorAll("p");
                            Array.prototype.forEach.call(pList, (item, index, arr) => {
                                item.className.indexOf("active") != -1 && activeNum++;
                            });
                            multiShipEl.style.height = `${activeNum * 12 + height}px`;
                        })
                    });
                }
            });
        },
        // tags展开/收起
        tagCollapse(i) {
            // tag项大于3才能展开
            if (this.tagList[i].cat_id.length > 3) {
                let height = 100;
                let activeNum = 0;
                let multiShipEl = this.$refs["multiShip" + i][0];
                // 获取激活项数量
                let pList = multiShipEl.querySelectorAll("p");
                Array.prototype.forEach.call(pList, (item, index, arr) => {
                    // console.log(item.className);
                    item.className.indexOf("active") != -1 && activeNum++;
                });
                this.$set(
                    this.tagList[i],
                    "collapse",
                    !this.tagList[i].collapse
                );
                // 展开
                if (this.tagList[i].collapse) {
                    height +=
                        (this.tagList[i].cat_id.length - 2) * 20 +
                        activeNum * 12 +
                        10;
                    // console.log("height: ", height);
                    multiShipEl.style.height = `${height}px`;
                }
                // 收起
                else {
                    multiShipEl.style.height = `${activeNum * 12 + height}px`;
                    if (activeNum > 3) {
                        multiShipEl.style.height = `135px`;
                    }
                }
            }
        },
        // 初始化tags高度
        initTagsHeight() {
            this.searchForm.tags = [];
            this.tagList.forEach((item) => {
                item.cat_id.forEach((sItem) => {
                    sItem.index = null;
                });
            });
            let index = 0;
            for (var name in this.$refs) {
                if (name.includes("multiShip")) {
                    // 收起所有tags
                    this.$set(this.tagList[index], "collapse", false);
                    // 设初始高度
                    this.$refs[name][0].style.height = "100px";
                    index++;
                }
            }
        },
        setShowSortList(status) {
            if (status) {
                clearInterval(this.showSortInterval);
                this.showSortList = true;
            } else {
                const that = this
                // this.showSortInterval = setInterval(() => {
                that.showSortList = false;
                // }, 50);
            }
        },
        setShowFilterList(status) {
            if (status) {
                // clearInterval(this.showFilterInterval);
                this.filterSettedTmp = JSON.parse(JSON.stringify(this.filterSetted));
                this.showFilterList = true;
            } else {
                const that = this
                // this.showFilterInterval = setInterval(() => {
                that.showFilterList = false;
                // }, 100);
            }
        },
        setTmpTag(tagItem) {
            let idx = -1
            const { tags } = this.filterSettedTmp
            for (let i = 0; i < tags.length; i++) {
                if (tags[i].id === tagItem.id) {
                    idx = i;
                    break;
                }
            }

            if (idx > -1) {
                tags.splice(idx, 1);
            } else {
                tags.push(tagItem);
            }
        },
        setTmpTime(TimeItem) {
            let idx = -1
            const { processing_time } = this.filterSettedTmp
            for (let i = 0; i < processing_time.length; i++) {
                if (processing_time[i].value === TimeItem.value) {
                    idx = i;
                    break;
                }
            }

            if (idx > -1) {
                processing_time.splice(idx, 1);
            } else {
                processing_time.push(TimeItem);
            }
        },
        setTag(tagItem) {
            let idx = -1
            const { tags } = this.filterSetted
            for (let i = 0; i < tags.length; i++) {
                if (tags[i].id === tagItem.id) {
                    idx = i;
                    break;
                }
            }

            if (idx > -1) {
                tags.splice(idx, 1);
            } else {
                tags.push(tagItem);
            }
        },
        confirmFilter() {
            this.filterSetted = JSON.parse(JSON.stringify(this.filterSettedTmp));
            // repair price
            if (this.filterSetted.price[0] > 0 && this.filterSetted.price[1] > 0 && parseFloat(this.filterSetted.price[0]) > parseFloat(this.filterSetted.price[1])) {
                this.filterSetted.price[1] = undefined;
            }
            this.setShowFilterList(false);
            //console.log(this.filterSetted.tags)
            //this.getGoodsList();
        },
        filterStyle() {
            let width = this.$refs.goodsListRef && (Math.floor((this.$refs.goodsListRef.offsetWidth+25)/(240+25)) * (240+25) - 25 - (this.$refs.controlBtnsFilter.$el.getBoundingClientRect().x - this.$refs.controlBtns.$el.getBoundingClientRect().x));
            let left = -1

            if (width < 600) {
                left = width - 600;
                width = 600;
            }

            width += 'px'
            left += 'px'

            return {width, left}
        }
    },
    activated() {
        this.$ga.event("engagement", "view_item_list");
        if (this.$route.name !== "goodsList") {
            const { path, query } = this.$route;
            this.subPageRefresh = true;
            this.subPageRefreshRoute = { path, query };
        }
        // 从url参数中，回显页面的筛选条件
        let { keyword, category_id, catParents, tags } = this.$route.query;
        keyword && (this.searchForm.keyword = keyword);
        category_id && (this.category_id = category_id);
        catParents && (this.catParents = catParents.split(",").map(n => Number(n)));
        tags && (this.searchForm.tags = tags.split(","));
        this.initialize().then(() => {
            if (this.subPageRefresh) {
                this.showDetail = true;
                this.$router.push(this.subPageRefreshRoute);
                this.subPageRefresh = false;
                this.subPageRefreshRoute = {};
            }
        });
    },
    deactivated() {
        this.category_id = "";
    },
    created() {
        this.roleId = localStorage.getItem("roleId");
    },
    components: {
        pagination,
        menuAuthBtn,
        statusTabs,
        searchTool,
        selectPlatform,
        //generate,
        selectShop,
        batchDownload,
    },
    computed: {
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
        ...mapState({
            staffList: (state) => state.index.staffList,
            goodsSelectdList: (state) => state.index.goodsSelectdList,
            screenResolution: (state) => state.index.screenResolution,
            routeObj: (state) => state.index.routeObj,
        }),
        height() {
            return `calc(100% - 120px - ${(this.hasSearchCondition ? "32px" : "0px") || ""
                }${(this.statusList instanceof Array &&
                    this.statusList.length > 0 &&
                    " - 47px") ||
                ""
                })`;
        },
        searchList() {
            return [
                {
                    label: this.$i18n.locale == "zh" ? "关键字" : "Keyword",
                    key: "keyword",
                    type: "input",
                },
                {
                    label:
                        this.$i18n.locale == "zh" ? "上线时间" : "New Arrival",
                    key: "new_arrival",
                    type: "input",
                },
                {
                    label: this.$i18n.locale == "zh" ? "价格" : "Price",
                    key: "price",
                    type: "input",
                },
                {
                    label: this.$i18n.locale == "zh" ? "重量" : "Weight",
                    key: "weight",
                    type: "input",
                },
                {
                    label:
                        this.$i18n.locale == "zh"
                            ? "发货时间"
                            : "Delivery Time",
                    key: "delivery_time",
                    type: "input",
                },
                {
                    label: this.$i18n.locale == "zh" ? "状态" : "Status",
                    key: "status",
                    type: "select",
                    props: {
                        list: this.statusList,
                        nameKey: "keyword",
                        valueKey: "status",
                    },
                },
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (
                        v instanceof Array
                            ? !!v.join("")
                            : !!v && k !== "status"
                    ) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
        $route: {
            handler: function (to, from) {
                if (to.path.indexOf("/goodsList") === 0) {
                    // 头部搜索框搜索
                    if (to.query.keyword) {
                        this.searchForm.keyword = to.query.keyword;
                        this.initialize().then(() => {
                            if (this.subPageRefresh) {
                                // console.log(this.subPageRefreshRoute, this.searchForm.keyword)
                                this.$router.replace({
                                    path: this.subPageRefreshRoute.path,
                                    query: this.searchForm.keyword
                                });
                                this.subPageRefresh = false;
                                this.subPageRefreshRoute = {};
                            }
                        });
                    }
                    if (to.name !== "goodsList" && from.name !== "goodsList") {
                        const { path, query } = this.$route;
                        this.subPageRefresh = true;
                        this.subPageRefreshRoute = { path, query };
                    } else if (
                        from.name !== "goodsList" &&
                        to.name === "goodsList"
                    ) {
                        // !to.query.back && (this.category_id = "");
                        this.$refs.goodsListRef.scrollTop = this.scroll;
                        this.initialize().then(() => {
                            if (from.name !== 'goodsDetail' && this.subPageRefresh) {
                                this.$router.push(this.subPageRefreshRoute);
                                this.subPageRefresh = false;
                                this.subPageRefreshRoute = {};
                            }
                        });
                    } else if (to.name === "goodsDetail") {
                        // 详情
                        this.showDetail = true;
                    }
                }
            },
            // 深度观察监听
            deep: true,
        },
        filterSetted: {
            handler(nv, ov) {
                if (this.$refs.navItems) {
                    this.navWidth = this.$refs.navItems.$el.offsetWidth + 1
                    this.$nextTick(function() {
                        this.navHeight = this.$refs.navContainer.offsetHeight
                    })
                }
                this.getGoodsList();
            },
            deep: true,
            immediate: true
        }
    },
};
</script>
<style lang="scss">
$color-e7e7e7: #e7e7e7;
$color-ededed: #ededed;

.goodsList {
    width: 100%;
    height: 100%;
    background: #fff;

    .goods-container {
        text-align: left;
        padding: 15px 17px;
        border-top: 1px solid $color-e7e7e7;
        display: flex;

        .tree-wrap {
            min-width: 220px;
            max-width: 350px;
            border: 1px solid $color-e7e7e7;
            height: 100%;
            font-size: 12px;
            overflow: hidden;
            flex: 0;
            padding: 5px 15px 15px;

            .multi-filter-item {
                padding: 10px 5px;
                -moz-box-flex: 1;
                flex: 1 1;
                font-size: 14px;
                box-sizing: border-box;
                // padding-bottom: 20px;
                // border-bottom: 1px solid #e7e7e7;

                // &.no-border {
                //     border-bottom: 0;
                // }

                .header {
                    display: -moz-box;
                    display: flex;
                    -moz-box-pack: justify;
                    justify-content: space-between;
                    -moz-box-align: center;
                    align-items: center;
                    margin-bottom: 12px;
                }

                .title {
                    font-weight: 600;
                    line-height: 20px;
                    color: #222;
                }

                .category-group-list {
                    a {
                        text-decoration: none;
                        outline: none;
                    }

                    .category-list {
                        margin-bottom: -6px;
                        display: -moz-box;
                        display: flex;
                        -moz-box-orient: vertical;
                        -moz-box-direction: normal;
                        flex-direction: column;
                        margin: 0;
                        padding: 0;
                        position: relative;

                        li {
                            margin-bottom: 6px;
                            line-height: 22px;
                            color: #666;
                            cursor: pointer;
                            list-style: none;

                            a {
                                color: #666;
                                text-decoration: none;
                                background-color: transparent;
                                outline: none;
                                cursor: pointer;
                                -webkit-transition: color 0.3s;
                                transition: color 0.3s;
                                -webkit-text-decoration-skip: objects;

                                .category-name-txt {
                                    display: inline-block;
                                    // max-width: 130px;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    vertical-align: middle;
                                }

                                .category-count-txt {
                                    font-style: normal;
                                    font-size: 12px;
                                    color: #666;
                                    margin-left: 2px;
                                }
                            }

                            .arrow {
                                position: absolute;
                                right: 0;
                                border: 1px solid #666;
                                border-left: none;
                                border-top: none;
                                transform: rotate(-45deg) translateY(-22px);
                                width: 8px;
                                height: 8px;
                                box-sizing: border-box;
                            }

                            &:hover {
                                a {
                                    color: #635cff;
                                    font-weight: bold;
                                }

                                .arrow {
                                    border-color: #635cff;
                                    border-width: 2px;
                                }
                            }
                        }
                    }

                    .sub-category-list {
                        position: absolute;
                        background: #fff;
                        border: 1px solid #e7e7e7;
                        width: 756px;
                        height: calc(100% - 100px);
                        top: 73px;
                        left: 268px;
                        z-index: 999;
                        box-shadow: 1px 0px 2px rgb(0 0 0 / 12%);
                        
                        >div {
                            // display: grid;
                            // grid-column: 3;
                            // column-gap: 38px;
                            // grid-template-columns: 30% auto auto;
                            display: flex;
                            flex-flow: row wrap;

                            .category-item-list {
                                padding: 24px;
                                --line-height: 28px;
                                
                                .title a {
                                    color: #222;
                                    line-height: var(--line-height);

                                    &:hover {
                                        color: #635cff;
                                    }
                                }

                                .child-list {
                                    a {
                                        color: #666;
                                        line-height: var(--line-height);

                                        &:hover {
                                            color: #635cff;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // .category-tree {
                    //     color: #666;
                    //     line-height: 22px;

                    //     a {
                    //         color: #666;

                    //         &:focus {
                    //             outline: none;
                    //         }
                    //     }

                    //     .tree-item {
                    //         margin-top: 6px;

                    //         a {
                    //             overflow: hidden;
                    //             text-overflow: ellipsis;
                    //             display: -webkit-box;
                    //             -webkit-line-clamp: 2;
                    //             line-clamp: 2;
                    //             -webkit-box-orient: vertical;

                    //             .category-name-txt {
                    //                 display: inline-block;
                    //                 // max-width: 130px;
                    //                 white-space: nowrap;
                    //                 overflow: hidden;
                    //                 text-overflow: ellipsis;
                    //                 vertical-align: middle;

                    //                 &.category-leaf-name-txt {
                    //                     padding-left: 19px;
                    //                 }
                    //             }

                    //             .category-count-txt {
                    //                 font-style: normal;
                    //                 font-size: 13px;
                    //                 color: #666;
                    //                 margin-left: 2px;
                    //             }
                    //         }

                    //         &.active {
                    //             >a {
                    //                 color: #222;
                    //                 font-weight: 600;

                    //                 .category-name-txt {
                    //                     padding-left: 11px;
                    //                 }
                    //             }
                    //         }
                    //     }

                    //     .tree-more {
                    //         padding-left: 19px;
                    //     }
                    // }

                    // .common-more {
                    //     margin-top: 6px;
                    //     line-height: 20px;
                    //     color: #666;
                    //     -moz-text-decoration-line: underline;
                    //     text-decoration-line: underline;
                    //     cursor: pointer;
                    // }
                }
            }

            .tree-wrap-title {
                // border-bottom: 1px solid $color-e7e7e7;
                padding: 10px 5px;
                font-size: 14px;
                font-weight: bold;
                cursor: pointer;
                transition: all 0.6s;

                &:hover {
                    background: #edeeef;
                    color: $color-primary;
                }

                &:active {
                    opacity: 0.6;
                }
            }

            .tree-wrap-filter {

                // border-bottom: 1px solid $color-e7e7e7;
                .el-button {
                    width: 100%;
                    background-color: #fff;
                    color: #202223;
                    // border-color: #e7e7e7;
                    border: none;
                    font-weight: bold;
                    text-align: left;

                    &+.el-button {
                        border-top: 1px solid #e7e7e7;
                        border-bottom: 1px solid #e7e7e7;
                        margin-left: 0;
                    }
                }
            }

            .tree-scrollbar {
                padding-bottom: 20px;
                border-bottom: 1px solid $color-e7e7e7;

                .el-tree {
                    padding: 0 5px 10px;
                    box-sizing: border-box;

                    .el-tree-node__label {
                        font-size: 13px;
                        color: #333;
                    }
                }
            }

            .price-filter {
                margin-top: 10px;
                padding-bottom: 20px;
                border-bottom: 1px solid #e7e7e7;
            }

            .range-input {
                display: flex;
                align-items: center;
                position: relative;
                border: 1px solid #eeeeee;
                border-radius: 4px;
                overflow: hidden;
                font-size: 14px;

                .separator {
                    margin: 0 5px;
                }

                .el-input {
                    width: 80px;

                    .el-input__inner {
                        width: 100%;
                        border-color: transparent;
                        padding-left: 20px;
                        padding-right: 20px;

                        &:focus {
                            border-color: $color-primary;
                        }
                    }
                }

                .el-button {
                    padding: 10px;
                    font-size: 14px;
                    background-color: #fafafa;
                }
            }

            .multi-filter {
                margin: 20px 0 0;

                .multi-filter-item {
                    flex: 1 1;

                    .header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 12px;

                        .title {
                            font-weight: 600;
                            font-size: 13px;
                            line-height: 20px;
                            color: #222;
                        }
                    }

                    .multi-ship {
                        display: flex;
                        flex-direction: column;
                        margin-bottom: -6px;
                        height: 100px;
                        overflow: hidden;
                        position: relative;
                        transition: height 0.6s;

                        .ship-item {
                            position: relative;
                            margin-bottom: 6px;
                            font-size: 13px;
                            line-height: 20px;
                            cursor: pointer;
                            transition: all 0.4s;

                            .ship-name {
                                color: #666;
                            }

                            .el-icon-close {
                                cursor: pointer;
                                display: none;
                                position: absolute;
                                top: 50%;
                                right: 5px;
                                transform: translateY(-50%);
                                font-size: 18px;

                                &:active {
                                    opacity: 0.8;
                                }
                            }
                        }

                        .active {
                            cursor: auto;
                            padding: 5px 8px;
                            border: 1px solid $color-primary;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            width: 85%;

                            & .ship-name,
                            .el-icon-close {
                                color: $color-primary;
                            }

                            & .el-icon-close {
                                display: block;
                            }
                        }

                        .drop-down {
                            position: absolute;
                            bottom: 0;
                            width: 100%;
                            height: 20px;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            background: #fff;

                            // border-top: 1px solid #e7e7e7;
                            .drop-down_img {
                                width: 10px;
                                cursor: pointer;
                            }
                        }
                    }

                    &:not(:last-child) {
                        margin-bottom: 10px;
                    }
                }
            }

            .font-bold {
                font-weight: bold;
            }
        }

        .goods-wrap {
            margin-left: 30px;
            flex: 1;

            .filter-wrap {
                margin-bottom: 20px;
                // display: flex;
                // justify-content: space-between;
                align-items: center;


                // .el-button-group {
                //     // width: 100%;
                // }

                .nav {
                    // display: flex;
                    // align-items: center;
                    margin-bottom: 10px;
                    min-height: 33px;

                    .el-breadcrumb {
                        vertical-align: top;
                        line-height: 28px;
                        display: inline-block;
                        .el-breadcrumb__item {
                            .el-breadcrumb__inner {
                                font-weight: bold;
                                cursor: pointer;

                                &:hover {
                                    color: #635cff;
                                }
                            }

                            &:last-child {
                                .el-breadcrumb__inner {
                                    cursor: default;
                                    font-weight: normal;

                                    &:hover {
                                        color: #606266;
                                    }
                                }
                            }
                        }
                    }

                    .selected-tags {
                        display: inline-block;
                        margin-left: 30px;
                        .el-tag {
                            margin-right: 5px;
                            margin-bottom: 5px;

                            &+.el-tag {
                                margin-left: 0;
                            }

                            &:last-child {
                                margin-right: 0;
                            }
                        }
                        .cleaner {
                            color: #f56c6c;
                            margin-left: 10px;
                            text-decoration: none;
                            outline: none;
                            font-size: 12px;
                            white-space: nowrap;
                        }
                    }
                }

                .el-button {
                    background-color: #fff;
                    color: #202223;
                    border-color: #babfc3;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    font-weight: bold;
                    height: 36px;

                    &:first-child {
                        border-top-left-radius: 3px;
                        border-bottom-left-radius: 3px;
                    }

                    &:last-child {
                        border-top-left-radius: 0;
                        border-bottom-left-radius: 0;
                        border-top-right-radius: 3px;
                        border-bottom-right-radius: 3px;
                    }

                    &:hover {
                        opacity: 1;
                        z-index: 101;
                    }

                    .select-img {
                        position: absolute;
                        width: 18px;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 15px;
                    }

                    .select-label {
                        padding-left: 22px;
                    }

                    .el-icon-caret-bottom {
                        position: relative;
                        left: 8px;
                    }

                    .sort-type {
                        margin-left: 5px;
                        color:#999;
                    }

                    ul.sort-list {
                        text-align: left;
                        position: absolute;
                        background-color: #fff;
                        padding: 10px 0;
                        top: 35px;
                        border: 1px solid #635cff;
                        width: calc(100% + 2px);
                        box-sizing: border-box;
                        left: -1px;

                        li {
                            padding: 0 20px;

                            a {
                                text-decoration: none;
                                font-weight: normal;
                                color: #606266;
                                line-height: 30px;
                                outline: none;
                                display: block;
                            }

                            &:hover, &.active {
                                background-color: #645cff1b;

                                a {
                                    color: #635cff;
                                }
                            }
                        }
                    }

                    .filter {
                        text-align: left;
                        position: absolute;
                        background-color: #fff;
                        padding: 0;
                        top: 35px;
                        border: 1px solid #635cff;
                        min-width: 600px;
                        box-sizing: border-box;
                        left: -1px;
                        z-index: 101;

                        .tag-group {
                            display: flex;
                            align-items: start;
                            line-height: 24px;
                            padding: 10px 0;

                            .group-name {
                                box-sizing: border-box;
                                width: 160px;
                                padding: 0 20px 0;
                                text-align: right;
                                line-height: 30px;
                            }

                            .item-list {
                                width: calc(100% - 100px);
                                box-sizing: border-box;
                                white-space: normal;
                                margin-bottom: -10px;

                                a {
                                    text-decoration: none;
                                    font-weight: normal;
                                    color: #606266;
                                    line-height: 28px;
                                    outline: none;
                                    border: 1px solid #fff;
                                    padding: 0 10px;
                                    display: inline-block;
                                    margin-right: 10px;
                                    margin-bottom: 10px;
                                    position: relative;

                                    >span {
                                        display:none;
                                    }

                                    &.active {
                                        border-color: #635cff;

                                        >span {
                                            display: block;
                                            width: 6px;
                                            height: 6px;
                                            line-height: 6px;
                                            background-color: #635cff;
                                            border: 6px solid #fff;
                                            border-bottom-color: #635cff;
                                            border-right-color: #635cff;
                                            position: absolute;
                                            bottom: 0;
                                            right: 0;
                                            box-sizing: border-box;

                                            i {
                                                border: 1px solid #fff;
                                                width: 2px;
                                                height: 4px;
                                                transform: rotate(40deg);
                                                display: block;
                                                border-top: 0;
                                                border-left: 0;
                                                margin-left: 1px;
                                                margin-top: -1px;
                                            }
                                        }
                                    }

                                    &:last-child {
                                        margin-right: 0;
                                    }
                                }


                                .price-range {
                                    border: 1px solid #babfc3;
                                    width: max-content;

                                    .el-input {
                                        width: 100px;

                                        input {
                                            text-align: center;
                                            border: none;
                                        }
                                    }
                                }
                            }

                            &+.tag-group {
                                border-top: 1px dotted #e7e7e7;
                            }
                        }

                        .el-row {
                            margin-top: 10px;
                            text-align: right;
                            padding: 0 20px 20px;

                            .el-button {
                                border-radius: 0;

                                &--primary {
                                    color: white;
                                    background-color: #635cff;
                                    border-color: #635cff;
                                }

                                &+.el-button {
                                    margin-left: 20px;
                                }
                            }
                        }
                    }

                    i.el-icon-arrow-down, i.el-icon-arrow-up {
                        color: #666;
                        margin-right: -10px;
                        margin-left: 10px;
                    }
                }
            }

            .goods-list {
                overflow-y: auto;

                .cards-wrap {
                    display: flex;
                    flex-wrap: wrap;

                    .card-item {
                        position: relative;
                        width: 240px;
                        min-height: 290px;
                        border-radius: 4px;
                        border: 1px solid #ededed;
                        margin: 0 25px 40px 0;
                        padding: 10px 15px 20px;
                        box-sizing: border-box;
                        transition: all 0.1s;

                        // @media screen and (max-width: 1279px) {
                        //     &:nth-child(2n) {
                        //         margin-right: 0;
                        //     }
                        // }
                        // @media screen and (min-width: 1280px) and (max-width: 1539px) {
                        //     &:nth-child(3n) {
                        //         margin-right: 0;
                        //     }
                        // }
                        // @media screen and (min-width: 1540px) and (max-width: 1899px) {
                        //     &:nth-child(4n) {
                        //         margin-right: 0;
                        //     }
                        // }
                        // @media screen and (min-width: 1900px) {
                        //     &:nth-child(5n) {
                        //         margin-right: 0;
                        //     }
                        // }
                        .check-box {
                            position: absolute;
                            display: none;
                            top: 0;
                            right: 0;
                            width: 24px;
                            height: 24px;
                            z-index: 100;
                            cursor: pointer;

                            img {
                                width: 100%;
                            }
                        }

                        .thumb {
                            cursor: pointer;
                            width: 100%;
                            height: 220px;
                            // background: $color-e7e7e7;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            overflow: hidden;
                        }

                        .product-detail {
                            transition: all 0.1s;
                            overflow: hidden;
                            position: relative;
                            background: rgba(255, 255, 255, 0.9);

                            .title {
                                cursor: pointer;
                                color: #000;
                                font-size: 14px;
                                font-weight: bold;
                                margin: 20px 0 15px;
                                line-height: 20px;
                                height: 60px;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 3;
                                overflow: hidden;
                            }

                            .subtitle {
                                font-size: 13px;
                                width: 100%;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;

                                .subtitle-price {
                                    color: #000;
                                    font-size: 15px;
                                    font-weight: bold;
                                    margin-left: 5px;
                                }
                            }

                            .operations {
                                display: flex;
                                justify-content: space-between;
                                margin: 15px 0 0;
                                position: absolute;
                                left: 0;
                                right: 0;

                                .el-button {
                                    width: 70%;
                                    border-radius: 4px;
                                }

                                .el-image {
                                    position: relative;
                                    right: -8px;
                                    width: 20px;
                                    margin: 0 auto;
                                }
                            }
                        }

                        &:hover {
                            border-color: $color-primary;
                            box-shadow: 0 2px 3px 2px rgba(100, 100, 100, 0.1);

                            .check-box {
                                display: block;
                            }

                            .product-detail {
                                margin-top: -48px;
                                z-index: 1;
                                position: relative;
                                padding-bottom: 48px;
                            }
                        }
                    }

                    .card-item-select {
                        border-color: $color-primary;
                        box-shadow: 0 2px 3px 2px rgba(100, 100, 100, 0.1);

                        .check-box {
                            display: block;
                        }
                    }
                }
            }
        }

        .goods-detail {
            flex: 1;
        }

        .el-scrollbar {
            .el-scrollbar__wrap {
                overflow: hidden;
                overflow-y: scroll;
            }
        }
    }
}

.filter-popover {
    position: relative;
    padding: 20px 20px 40px;

    .filter-popover-items {
        .filter-popover-item {
            font-size: 12px;
            color: #333;
            display: flex;
            align-items: center;

            .filter-popover-item-label {
                text-align: right;
                width: 20%;
            }

            .filter-popover-item-content {
                position: relative;
                margin-left: 29px;
                display: flex;
                align-items: center;

                .filter-popover-item-content-value {
                    padding: 1px 4px;
                    border-radius: 2px;
                    cursor: pointer;

                    &:not(:last-child) {
                        margin-right: 10px;
                    }

                    &.active {
                        background-color: $color-primary-blue;
                        color: #fff;
                    }
                }

                .question {
                    position: absolute;
                    left: -21px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: $color-primary-blue;
                    font-size: 14px;
                }
            }

            &+.filter-popover-item {
                margin-top: 22px;
            }
        }
    }

    .search {
        position: absolute;
        right: 20px;
        bottom: 0;
    }
}
</style>
